import { POST_API } from 'middlewares/form';
import { CALL_API } from 'middlewares/api';
import LGTM from 'lgtm';
import { calculateTotalAmount, getAccordianHeading } from '../utils/GlobalUtils';
import root from 'window-or-global';
import { TOTAL_AMOUNT_CAN_CHANGE } from '../constants/GlobalConstants';

/**
 * Called when Editing anything in the Initialize Form
 * @param {Object} changedData - {name: 'Aakash'}
 */

export const HANDLE_IP_CHANGE_INPUT = 'HANDLE_IP_CHANGE_INPUT';
export function handleChangeInput (changedData, totalAmountCanChange) {
  return (dispatch, getState, isOfferPage) => {
    dispatch({
      type: HANDLE_IP_CHANGE_INPUT,
      payload: {
        changedData,
      },
    });
    const state = isOfferPage ? getState().payments : getState();

    let shippingPayload = {
        ...state.initializePurchase.form,
        ...changedData,
    };
    if (totalAmountCanChange) {
      callShippingCharges(dispatch, getState(), shippingPayload);
      setTotalAmountAndAccordianHeading(
        dispatch,
        calculateTotalAmount(state.initializePurchase),
      );
    }
  };
}

function callShippingCharges(dispatch, state, payload){
  //Note :This is done to get the value of PWYW field and send it as a param with key as total_amount.
  payload.totalAmount = payload.amount;

  if (state.offerDetails && root.INITIAL_STATE.offer &&  root.INITIAL_STATE.offer.type === 'physical' && root.INITIAL_STATE.is_shipping_charges_enabled){
      dispatch(getShippingCharges(payload));
  }
}

function setTotalAmountAndAccordianHeading (dispatch, totalAmount) {
  dispatch(handleSetTotalAmount(totalAmount));
  dispatch(handleSetAccordianHeading(totalAmount));
}

/**
 * Called when clicking link which says "I have a discount code"
 */

export const SHOW_DISCOUNT_CODE_BOX = 'SHOW_DISCOUNT_CODE_BOX';
export function showDiscountCodeBox () {
  return {
    type: SHOW_DISCOUNT_CODE_BOX,
  };
}

/**
 * [same endpoint used by both apply and remove discount code API]
 * @return {[String]} [/<username>/<slug>/discount/]
 */

const discountEndpoint = (store) => {
  const { slug } = store.initializePurchase.offer;
  return `/checkout${slug}discount/`;
};

/**
 * Called to when applying Discount
 */
const discountCodeValidator =
 LGTM.validator()
   .validates('discountCode')
     .required('Enter a discount code')
   .build();

export const HANDLE_APPLY_DISCOUNT_REQUEST = 'HANDLE_APPLY_DISCOUNT_REQUEST';
export const HANDLE_APPLY_DISCOUNT_SUCCESS = 'HANDLE_APPLY_DISCOUNT_SUCCESS';
export const HANDLE_APPLY_DISCOUNT_FAILURE = 'HANDLE_APPLY_DISCOUNT_FAILURE';
export function handleApplyDiscount () {
  return {
    [POST_API]: {
      types: [HANDLE_APPLY_DISCOUNT_REQUEST, HANDLE_APPLY_DISCOUNT_SUCCESS, HANDLE_APPLY_DISCOUNT_FAILURE],
      endpoint: discountEndpoint,
      validator: discountCodeValidator,
      toValidate: (store) => {
        const { discountCode } = store.initializePurchase.form;
        return { discountCode };
      },
      failureActionErrors: (response) => {
        return {
          discountCode: [response.errors.discount],
        };
      },
      onSuccess: (response, state, dispatch) => {
        //Calculating shipping charges once discount amount is retrieved.
        callShippingCharges(dispatch, state, state.initializePurchase.form);
        setTotalAmountAndAccordianHeading(dispatch, calculateTotalAmount(state.initializePurchase));
      },
      payload: (store) => {
        const { discountCode } = store.initializePurchase.form;
        return {
          discount: discountCode,
        };
      },
    },
  };
}

/**
 * Called when removing discount
 */

export const HANDLE_REMOVE_DISCOUNT_REQUEST = 'HANDLE_REMOVE_DISCOUNT_REQUEST';
export const HANDLE_REMOVE_DISCOUNT_SUCCESS = 'HANDLE_REMOVE_DISCOUNT_SUCCESS';
export const HANDLE_REMOVE_DISCOUNT_FAILURE = 'HANDLE_REMOVE_DISCOUNT_FAILURE';
export function handleRemoveDiscount () {
  return {
    [POST_API]: {
      types: [HANDLE_REMOVE_DISCOUNT_REQUEST, HANDLE_REMOVE_DISCOUNT_SUCCESS, HANDLE_REMOVE_DISCOUNT_FAILURE],
      endpoint: discountEndpoint,
      payload: {
        discount: '',
      },
      onSuccess: (response, state, dispatch) => {
        //Calculating shipping charges once discount amount is removed.
        callShippingCharges(dispatch, state, state.initializePurchase.form);
        setTotalAmountAndAccordianHeading(dispatch, calculateTotalAmount(state.initializePurchase));
      },
    },
  };
}

/**
 * Called when Submitting Initialize Purchase Form
 */
import { getVariantCategoryName } from '../utils/InitializePurchaseUtils';
import { unbuiltInitializeFormValidator } from './initialize/validator';

function getSelectedVariants (variantCategories, form) {
  return variantCategories.reduce((validationFields, variantCategory) => {
    const variantFieldName = getVariantCategoryName(variantCategory.id);
    validationFields[variantFieldName] = form[variantFieldName];
    return validationFields;
  }, {});
}

export const HANDLE_SUBMIT_INITIALIZE_PURCHASE_REQUEST = 'HANDLE_SUBMIT_INITIALIZE_PURCHASE_REQUEST';
export const HANDLE_SUBMIT_INITIALIZE_PURCHASE_SUCCESS = 'HANDLE_SUBMIT_INITIALIZE_PURCHASE_SUCCESS';
export const HANDLE_SUBMIT_INITIALIZE_PURCHASE_FAILURE = 'HANDLE_SUBMIT_INITIALIZE_PURCHASE_FAILURE';
let initialPayload = {};
import { storeInitialPayload } from './RefinePurchaseActions';
import { storeFinalPayload } from './FinalizePurchaseActions';
import { mapPayloadForClient, mapPayloadForServer } from '../utils/InitializePurchaseUtils';
import { getOrderEndpoint, getShippingChargesEndPoint } from '../utils/GlobalUtils';


export const initializePurchaseValidator = ({ store, initialValidator }) => {
  if (!initialValidator) {
    initialValidator = LGTM.validator();
  }

  const { variantCategories, priceBoost, basePrice } = store.initializePurchase.offer;


  if (priceBoost) {
    initialValidator = initialValidator
      .validates('amount')
      .using(amount => amount >= basePrice, `Minimum amount is Rs.${basePrice}`);
  }

  if (variantCategories && variantCategories.length) {
    variantCategories.forEach(variantCategory => {
      initialValidator = initialValidator
        .validates(getVariantCategoryName(variantCategory.id))
        .required('Please select an option');
    });
  }
  return initialValidator.build();
};

export const initializePurchaseToValidate = ({ store, initialToValidate }) => {
  if (!initialToValidate) {
    initialToValidate = {};
  }

  const {
    form,
    form: { amount },
    offer: { variantCategories, priceBoost },
  } = store.initializePurchase;

  let toValidate = {
    ...initialToValidate,
  };

  if (priceBoost) {
    toValidate = {
      ...toValidate,
      amount,
    };
  }

  if (variantCategories && variantCategories.length) {
    const variantValidations = getSelectedVariants(variantCategories, form);
    toValidate = {
      ...toValidate,
      ...variantValidations,
    };
  }

  return toValidate;
};

export const initializePurchasePayload = ({ store, isDirectPurchase }) => {
  const {
    form,
    form: {
      name, email, phone, discountCode, isQuantityApplicable,
      quantity, isClaimFreeChecked, amount, selectedSocialPayPlatform,
      readOnly,
    },
    offer: {
      variantCategories, priceBoost, basePrice, socialpayPlatforms,
      title,
    },
    prefilledHiddenCustomFields, signature, affiliate,
    isInstapayPayment, isRAP,
  } = store.initializePurchase;

  let tentativePayload = isDirectPurchase ? {
    name, email, phone, amount: amount ? amount : basePrice,
  } : {};

  if (isRAP) {
    return {
      ...tentativePayload,
      purpose: title,
    };
  }

  if (isInstapayPayment) {
    if (title) {
      tentativePayload = {
        ...tentativePayload,
        purpose: title,
      };
    }

    return {
      ...tentativePayload,
    };
  }

  let confirmedPayload = {
    ...tentativePayload,
    ...prefilledHiddenCustomFields,
  };

  if (affiliate) {
    confirmedPayload = {
      ...confirmedPayload,
      affiliate,
    };
  }

  if (discountCode) {
    confirmedPayload = {
      ...confirmedPayload,
      discountCode,
    };
  }

  if (isQuantityApplicable) {
    confirmedPayload = {
      ...confirmedPayload,
      quantity,
    };
  }

  if (priceBoost) {
    if ((basePrice > 0) || (basePrice === 0 && !isClaimFreeChecked)) {
      confirmedPayload = {
        ...confirmedPayload,
        amount,
      };
    }
  }

  if (socialpayPlatforms && selectedSocialPayPlatform) {
    confirmedPayload = {
      ...confirmedPayload,
      platform: selectedSocialPayPlatform,
    };
  }

  if (variantCategories && variantCategories.length) {
    const variantPayload = getSelectedVariants(variantCategories, form);
    confirmedPayload = {
      ...confirmedPayload,
      ...variantPayload,
    };
  }

  if (signature) {
    confirmedPayload = {
      ...confirmedPayload,
      signature,
      readOnly: JSON.stringify(
        mapPayloadForServer(
          Object.keys(readOnly).reduce((o, r) => {
            o[r] = form[r];
            return o;
          }, {})
        )
      ),
      readOnlyFieldsNetBanking: Object.keys(readOnly).map(field => `data_${field}`),
      hiddenCustomFieldsNetBanking: Object.keys(prefilledHiddenCustomFields).map(field => `data_${field}`),
    };
  }

  initialPayload = confirmedPayload;
  return mapPayloadForServer(confirmedPayload);
};

export const HANDLE_FETCH_SHIPPING_CHARGES_REQUEST = 'HANDLE_FETCH_SHIPPING_CHARGES_REQUEST';
export const HANDLE_FETCH_SHIPPING_CHARGES_SUCCESS = 'HANDLE_FETCH_SHIPPING_CHARGES_SUCCESS';
export const HANDLE_FETCH_SHIPPING_CHARGES_FAILURE = 'HANDLE_FETCH_SHIPPING_CHARGES_FAILURE';

export function getShippingCharges(data) {
  return {
    [CALL_API]: {
      types: [HANDLE_FETCH_SHIPPING_CHARGES_REQUEST, HANDLE_FETCH_SHIPPING_CHARGES_SUCCESS, HANDLE_FETCH_SHIPPING_CHARGES_FAILURE],
      endpoint: getShippingChargesEndPoint(data),
    },
  };
}

export const APPLY_BOOST_SUCCESS = 'APPLY_BOOST_SUCCESS';
export const APPLY_BOOST_FAILURE = 'APPLY_BOOST_FAILURE';

export function applyBoost(status) {
  return(dispatch, getState) => {

    const { is_cart_enabled: isCartEnabled } = root.INITIAL_STATE;
    const store = getState();

    //This is done to ALWAYS fetch the product details when cart is on / off.
    let paymentData = isCartEnabled && store.payments ? store.payments.initializePurchase : store.initializePurchase;

    //Update the  boostPrice in the store.
    dispatch({ type: APPLY_BOOST_SUCCESS, payload: status });

    const amount = parseFloat(paymentData.form.priceBoostAmount);
    const basePrice = parseFloat(paymentData.offer.basePrice);
    const changedAmount = paymentData.form.priceBoostAmount;
    //Validate the updated boost price
    const createPwywValidator = LGTM.validator()
      .validates('amount')
      .using(amount => amount >= basePrice, `Minimum amount is Rs.${basePrice}`)
      .using(amount => (amount >= 9 || amount == 0), 'Payment amount cannot be less than Rs. 9.00')
      .build();

      createPwywValidator.validate({
        amount,
        basePrice,
      }, (err, result) => {

        // If Invalid boost price then throw an error
        if (!result.valid) {
          dispatch({ type: APPLY_BOOST_FAILURE, errors: result.errors });
        }

        // Else update the totalAmount in the form
        else if (status === true) {
          dispatch(handleChangeInput({
            amount: changedAmount,
          }, TOTAL_AMOUNT_CAN_CHANGE));
        }
      });
    };
}


export function handleSubmitInitializePurchase () {
  return {
    [POST_API]: {
      types: [HANDLE_SUBMIT_INITIALIZE_PURCHASE_REQUEST, HANDLE_SUBMIT_INITIALIZE_PURCHASE_SUCCESS, HANDLE_SUBMIT_INITIALIZE_PURCHASE_FAILURE],
      endpoint: getOrderEndpoint(),
      validator: store => {
        return initializePurchaseValidator({
          store,
          initialValidator: unbuiltInitializeFormValidator(),
        });
      },
      toValidate: store => {
        const {
          form: { name, email, phone },
        } = store.initializePurchase;

        const initialToValidate = { name, email, phone };

        return initializePurchaseToValidate({ store, initialToValidate });
      },
      payloadAsIs: true,
      payload: store => initializePurchasePayload({
        store, isDirectPurchase: true,
      }),
      failureActionErrors: response => {
        return mapPayloadForClient(response.errors);
      },
      onSuccess: (response, store, dispatch) => {
        if (store.settings.isShowRefinePurchaseBox) {
          return dispatch(storeInitialPayload(initialPayload));
        }
        dispatch(storeFinalPayload(initialPayload));
      },
    },
  };
}

/**
 * Called to set the total amount of the payment
 */
export const HANDLE_SET_TOTAL_AMOUNT = 'HANDLE_SET_TOTAL_AMOUNT';
export function handleSetTotalAmount (totalAmount) {
  return {
    type: HANDLE_SET_TOTAL_AMOUNT,
    payload: {
      totalAmount: totalAmount ? Number(totalAmount) : 0,
    },
  };
}

/**
 * Called to set the total amount of the payment
 */
export const HANDLE_SET_ACCORDIAN_HEADING = 'HANDLE_SET_ACCORDIAN_HEADING';
export function handleSetAccordianHeading (totalAmount) {
  return {
    type: HANDLE_SET_ACCORDIAN_HEADING,
    payload: {
      heading: getAccordianHeading('InitializePurchase', totalAmount),
    },
  };
}


import { handleSetSocialPayPlatform, handleSetupSocialPayAuthCallbackListener } from './SocialPayActions';
export function handleSetSocialPayPlatformAndSubmitForm (platform) {
  return dispatch => {
    dispatch(handleSetSocialPayPlatform(platform));
    dispatch(handleSubmitInitializePurchase());
    dispatch(handleSetupSocialPayAuthCallbackListener());
  };
}



// WEBPACK FOOTER //
// ./src/payments/actions/InitializePurchaseActions.js